var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRainIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 348,
    viewBox: "0 0 384 348",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7094 89.0287C54.7094 89.6809 54.7182 90.3329 54.735 90.9849C40.7316 94.0599 28.0256 101.421 18.3175 112.016C6.51 124.903 -0.000228882 141.589 -0.000228882 159.073C-0.000228882 177.622 7.30401 195.252 20.4181 208.366C33.5315 221.48 51.1622 228.784 69.7111 228.784H314.289C332.837 228.784 350.468 221.48 363.582 208.366C376.696 195.252 384 177.622 384 159.073C384 142.14 377.9 125.938 366.751 113.199C356.879 101.918 343.654 94.1017 329.019 90.9479C322.664 75.5121 312.034 62.1405 298.454 52.4233C283.346 41.6135 265.389 35.8669 246.813 35.8669C240.563 35.8669 234.326 36.5262 228.213 37.8299C224.793 38.5592 221.419 39.494 218.111 40.6252C210.787 29.3673 200.982 19.8676 189.473 12.9133C175.593 4.52658 159.799 0.153252 143.585 0.153252C119.936 0.153252 97.4604 9.46503 80.7407 26.1851C64.0213 42.9045 54.7095 65.38 54.7095 89.0286L54.7094 89.0287Z",
    fill: "#78909C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.567 250.4C119.253 258.474 106.426 282.511 123.567 284.529C123.672 284.517 123.775 284.504 123.878 284.49C140.551 282.218 127.854 258.425 123.567 250.4V250.4Z",
    fill: "#1E88E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.811 250.4C210.498 258.474 197.671 282.511 214.811 284.529C214.916 284.517 215.02 284.504 215.122 284.49C231.795 282.218 219.099 258.425 214.811 250.4V250.4Z",
    fill: "#1E88E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.056 250.4C301.743 258.474 288.916 282.511 306.056 284.529C306.161 284.517 306.265 284.504 306.367 284.49C323.04 282.218 310.344 258.425 306.056 250.4V250.4Z",
    fill: "#1E88E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.684 313.718C165.37 321.792 152.544 345.829 169.684 347.847C169.789 347.835 169.893 347.822 169.995 347.808C186.668 345.536 173.972 321.743 169.684 313.718V313.718Z",
    fill: "#1E88E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.961 313.718C255.647 321.792 242.82 345.829 259.961 347.847C260.065 347.835 260.169 347.822 260.271 347.808C276.945 345.536 264.248 321.743 259.961 313.718V313.718Z",
    fill: "#1E88E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.9444 250.4C73.6307 258.474 60.8039 282.511 77.9444 284.529C78.0492 284.517 78.1525 284.504 78.2553 284.49C94.9283 282.218 82.2318 258.425 77.9444 250.4V250.4Z",
    fill: "#1E88E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.189 250.4C164.875 258.474 152.049 282.511 169.189 284.529C169.294 284.517 169.398 284.504 169.5 284.49C186.173 282.218 173.477 258.425 169.189 250.4V250.4Z",
    fill: "#1E88E5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.434 250.4C256.12 258.474 243.293 282.511 260.434 284.529C260.539 284.517 260.642 284.504 260.745 284.49C277.418 282.218 264.722 258.425 260.434 250.4V250.4Z",
    fill: "#1E88E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.546 313.718C120.232 321.792 107.405 345.829 124.546 347.847C124.651 347.835 124.754 347.822 124.857 347.808C141.53 345.536 128.833 321.743 124.546 313.718V313.718Z",
    fill: "#1E88E5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.823 313.718C210.509 321.792 197.682 345.829 214.823 347.847C214.927 347.835 215.031 347.822 215.133 347.808C231.806 345.536 219.11 321.743 214.823 313.718V313.718Z",
    fill: "#1E88E5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainIcon);
export default __webpack_public_path__ + "static/media/rain-icon.0c6a27b04f3bfec410bb84898ad37634.svg";
export { ForwardRef as ReactComponent };